/* eslint-disable camelcase */
import { ChevronRightRounded } from '@mui/icons-material';
import {
  Alert,
  Button,
  Container,
  Divider,
  Grid, IconButton, LinearProgress, MenuItem, Snackbar, TextField,
} from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { getDigitalBox } from '../../../../Redux/Models/box';
import { getAdminItemDetails, postItemToMarket, updateMarketItem } from '../../../../Redux/Models/market';
import { getCategories, getConditions, getVolumeUnit } from '../../../../Redux/Models/master';
import { fetchClient, onlyNumbers } from '../../../../Utils/helpers';
import Elements from '../../../Elements';
import { alphabets } from '../../../../Configs/alphabets';

export default function UpdateMarketItem({
  classes, error, message, newItem, isLoading, selectedItem,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { itemId } = useParams();
  const { master, box } = useSelector((state) => state);
  const { isLoadingVolumeUnit, volumeUnit } = master;
  const photoRef = useRef(null);
  const [activeStep, setActiveStep] = useState(1);
  const [popUp, setPopUp] = useState(false);
  const [wantToCancel, setWantToCancel] = useState(false);

  const [itemFields, setItemField] = useState({
    photo: '',
    name: '',
    description: '',
    category_id: '-',
    condition_id: '-',
    notes: '',
    year: null,
    tempVolume: '0',
    volume: null,
  });
  const [saleFields, setSaleField] = useState({
    sale_type: '-',
    is_sale: true,
    starting_price: '',
    bid_duration: '-',
  });
  const [boxFields, setBoxField] = useState({
    column: '',
    rack: '',
    row: '',
    warehouse_notes: '',
    safety_guarantee: true,
    verified_item_status: true,
  });

  const [selectedRack, setSelectedRack] = useState({});
  const [chooseBox, setChooseBox] = useState();
  const [confirmRack, setConfirmRack] = useState(false);

  useEffect(() => {
    if (selectedItem.item) {
      const {
        sale_type = '',
        price = 0,
        bid_duration = '',
        is_sale,
        name,
        description,
        volume,
        category_id,
        condition_id,
        notes,
        photo,
        year,
      } = selectedItem.item;
      setItemField({
        name,
        description,
        volume,
        category_id,
        condition_id,
        notes,
        photo,
        year,
      });
      setSaleField({
        sale_type,
        is_sale,
        starting_price: price,
        bid_duration,
      });
    }

    if (selectedItem.box) {
      const {
        column,
        rack,
        row,
        warehouse_notes,
        id,
      } = selectedItem.box;
      setBoxField({
        ...boxFields,
        column,
        rack,
        row,
        warehouse_notes,
        id,
      });
    }
  }, [selectedItem]);

  const toggleCancelPopup = () => {
    setWantToCancel(!wantToCancel);
  };

  const handleChangeItemField = (e) => {
    setItemField({ ...itemFields, [e.target.name]: e.target.value });
  };

  const handleChangeSaleField = (e) => {
    setSaleField({ ...saleFields, [e.target.name]: e.target.value });
  };

  const handleChangeBoxField = (e) => {
    setBoxField({ ...boxFields, [e.target.name]: e.target.value });
  };

  const handleSelectRack = (col) => {
    if (col.is_available) {
      setSelectedRack(col);
    }
  };

  const checkBeforeOpenConfirmation = () => {
    if (selectedRack.id) {
      setConfirmRack(true);
    }
  };

  const chooseRack = () => {
    if (selectedRack.id) {
      setBoxField({ ...boxFields, ...selectedRack, warehouse_notes: boxFields.warehouse_notes });
      setConfirmRack(false);
      setChooseBox(false);
    }
  };

  const nextStep = (next) => {
    setActiveStep(next);
    setPopUp(false);
  };

  useEffect(() => {
    if (itemId) {
      dispatch(getAdminItemDetails(itemId));
    }
  }, [itemId]);

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getConditions());
    dispatch(getDigitalBox());
    dispatch(getVolumeUnit());
  }, []);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const getImage = (name, step) => {
    if (step === activeStep) return Images[`${name}Active2`];
    if (step > activeStep) return Images[name];
    return Images.Check2;
  };

  const photoTrigger = (ref) => {
    ref?.current?.click();
  };

  const handleChangePhoto = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const acceptedExt = ['png', 'jpg', 'jpeg', 'gif'];
      const fileExt = file.name.split('.').reverse()[0];

      if (!acceptedExt.includes(fileExt?.toLowerCase())) {
        setSnackbar({ message: 'Sorry, You only can upload image file', severity: 'error', open: true });
        return;
      }

      const fileSize = file.size;
      if (fileSize > (10000 * 1000)) {
        setSnackbar({ message: 'Sorry, maximum file size is 10MB', severity: 'error', open: true });
        return;
      }

      setSnackbar({ message: 'Uploading...', severity: 'info', open: true });
      const body = new FormData();
      body.append('file', file);

      fetchClient({
        method: 'POST',
        url: '/upload',
        data: body,
      }).then((res) => {
        setItemField({ ...itemFields, photo: res.data.data.url });
        setSnackbar({ message: 'Successfully upload...', severity: 'success', open: true });
      }).catch((err) => {
        setSnackbar({ message: err.response.data.message, severity: 'error', open: true });
      });
    }
  };

  const renderText = () => {
    switch (activeStep) {
      case 4: return itemId ? 'Update item' : 'Post to market';
      default: return 'Next';
    }
  };

  const wantToContinue = () => {
    let valid = false;
    const showFormError = () => {
      setSnackbar({
        open: true,
        message: 'Please complete the form!',
        severity: 'error',
      });
    };
    switch (activeStep) {
      case 1: nextStep(2);
        break;
      case 2:
        if (boxFields.id && boxFields.warehouse_notes) {
          valid = true;
        } else {
          showFormError();
        }
        break;
      case 3:
        if ((saleFields.sale_type === 'Fixed Price' && saleFields.starting_price)
        || (saleFields.sale_type === 'Bid Price' && saleFields.starting_price && saleFields.bid_duration)) {
          nextStep(4);
        } else {
          showFormError();
        }
        break;
      case 4: valid = true;
        break;
      default: valid = false;
    }

    if (valid) {
      setPopUp(true);
    }
  };

  const [submitted, setSubmitted] = useState(false);
  const handlePostToMarket = () => {
    // post
    const end_date = new Date();
    if (saleFields.bid_duration !== '-') {
      end_date.setDate(end_date.getDate() + Number(saleFields.bid_duration || 0));
    }
    const body = {
      item: {
        ...itemFields,
        ...saleFields,
        volume: itemFields.tempVolume === '-' ? `${itemFields.volume} mL` : itemFields.tempVolume,
        starting_price: Number(saleFields.starting_price),
        end_date: end_date.toISOString(),
      },
      box: {
        ...boxFields,
        verified_item_status: true,
        safety_guarantee: true,
      },
    };
    if (itemId) {
      dispatch(updateMarketItem(itemId, body));
    } else {
      dispatch(postItemToMarket(body));
    }

    if (activeStep === 4) {
      setSubmitted(true);
    }
  };

  useEffect(() => {
    if (newItem && submitted) {
      setSnackbar({
        open: true,
        severity: 'success',
        message: itemId ? 'Successfully update market item' : 'Successfully add item to market',
      });

      setTimeout(() => {
        navigate(ROUTES.market(), 'replace');
      }, 1000);
    }
    // else if (newItem && activeStep === 2) {
    //   nextStep(3);
    // }
  }, [newItem, activeStep, submitted]);

  const renderItemDataForm = () => (
    <div className="info-card mt-5">
      <h3>Item data</h3>
      <Divider sx={{ mt: 2 }} />

      <div className="mt-3">
        <label>Wine name</label>
        <TextField fullWidth placeholder="Type wine name" value={itemFields.name} name="name" onChange={handleChangeItemField} />
      </div>

      <div className="mt-3">
        <label>Year of the wine</label>
        <TextField
          fullWidth
          placeholder="Type the year"
          value={Number(itemFields.year)}
          name="year"
          onChange={(e) => {
            setItemField((items) => ({ ...items, year: Number(onlyNumbers(e.target.value)) }));
          }}
        />
      </div>

      {/* <div className="mt-3">
        <label>Item amount</label>
        <TextField fullWidth placeholder="Type here" />
      </div> */}

      <div className="mt-3">
        <label>Wine volume</label>
        <TextField
          fullWidth
          placeholder="0"
          value={itemFields.tempVolume}
          onChange={(e) => {
            setItemField((items) => ({ ...items, tempVolume: e.target.value }));
          }}
          select
        >
          <MenuItem value="0" disabled>{isLoadingVolumeUnit ? 'Loading...' : 'Choose wine volume'}</MenuItem>
          {volumeUnit.map((unit) => (
            <MenuItem value={unit.option} key={unit.id}>{unit.option}</MenuItem>
          ))}
          <MenuItem value="-">Other</MenuItem>
        </TextField>
        {
          itemFields.tempVolume === '-' && (
            <TextField
              fullWidth
              sx={{ mt: 0.5 }}
              placeholder="Type your wine volume"
              value={itemFields.volume}
              onChange={(e) => {
                setItemField((items) => ({
                  ...items,
                  volume: Number(onlyNumbers(e.target.value)),
                }));
              }}
              InputProps={{
                endAdornment: (<span className="mute">ml</span>),
              }}
            />
          )
        }
      </div>

      <div className="mt-3">
        <label>Category</label>
        <TextField fullWidth select value={itemFields.category_id} name="category_id" onChange={handleChangeItemField}>
          <MenuItem value="-" disabled>Choose category</MenuItem>
          {master.categories.map((category) => (
            <MenuItem value={category.id} key={category.id}>{category.name}</MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mt-3">
        <label>Condition</label>
        <TextField fullWidth select value={itemFields.condition_id} name="condition_id" onChange={handleChangeItemField}>
          <MenuItem value="-" disabled>Choose condition</MenuItem>
          {master.conditions.map((condition) => (
            <MenuItem value={condition.id} key={condition.id}>{condition.name}</MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mt-3">
        <label>Note</label>
        <TextField fullWidth placeholder="Type here" multiline value={itemFields.notes} name="notes" onChange={handleChangeItemField} />
        <div className="right mute s-12 mt-1 weight-500">0/250</div>
      </div>

      <div className="mt-3">
        <div className="s-14 weight-500">Photos</div>
        <div className="mute s-14 mt-1">You can only add 1 photo, with max size 5MB</div>
        <div className="mt-2 flex gap-8">
          <input type="file" name="photo" hidden ref={photoRef} onChange={handleChangePhoto} />
          {itemFields.photo
            ? (
              <img
                width="120"
                height="120"
                alt="profile"
                src={itemFields.photo}
                className="rounded cover link"
                onClick={() => photoTrigger(photoRef)}
              />
            ) : (
              <div className="upload-sect" onClick={() => photoTrigger(photoRef)}>
                Photo
              </div>
            )}
        </div>
      </div>

    </div>
  );

  const renderStoragePlacementForm = () => (
    <div className="info-card mt-5">
      <h3>Warehouse validate</h3>
      <Divider sx={{ mt: 2 }} />
      <div className="mt-3">
        <label>Warehouse note</label>
        <TextField fullWidth placeholder="Type here" multiline value={boxFields.warehouse_notes} name="warehouse_notes" onChange={handleChangeBoxField} />
        <div className="right mute s-12 mt-1 weight-500">0/250</div>
      </div>
      <div className="mt-3">
        <div>Storage site</div>
        <TextField
          sx={{ mt: 1 }}
          fullWidth
          placeholder="Choose storage"
          disabled
          value={boxFields.id ? boxFields.column + boxFields.row : ''}
          InputProps={{
            endAdornment: (
              <IconButton sx={{ p: 0 }} onClick={() => setChooseBox(true)} disabled={!!itemId}>
                <ChevronRightRounded fontSize="large" />
              </IconButton>
            ),
          }}
        />
      </div>
    </div>
  );

  const renderMarketSaleForm = () => (
    <div className="info-card mt-5">
      <h3>Market sale</h3>
      <Divider sx={{ mt: 2 }} />
      <div className="mt-3">
        <label>Sale type</label>
        <TextField fullWidth select value={saleFields.sale_type} name="sale_type" onChange={handleChangeSaleField}>
          <MenuItem value="-" disabled>Choose Type</MenuItem>
          <MenuItem value="Fixed Price">Fixed price</MenuItem>
          <MenuItem value="Bid Price">Bid price</MenuItem>
        </TextField>
      </div>
      <div className="mt-3">
        <label>Sale To Market</label>
        <TextField fullWidth select value={saleFields.is_sale} name="is_sale" onChange={handleChangeSaleField}>
          <MenuItem value>Sale</MenuItem>
          <MenuItem value={false}>Not Sale</MenuItem>
        </TextField>
      </div>

      <div className="mt-3" hidden={saleFields.sale_type !== 'Fixed Price'}>
        <label>Sale price</label>
        <TextField
          fullWidth
          placeholder="123"
          InputProps={{
            startAdornment: (<strong className="s-16">₣</strong>),
          }}
          value={saleFields.starting_price}
          name="starting_price"
          onChange={handleChangeSaleField}
        />
      </div>

      <div className="mt-3" hidden={saleFields.sale_type !== 'Bid Price'}>
        <label>Starting price</label>
        <TextField
          fullWidth
          placeholder="123"
          InputProps={{
            startAdornment: (<strong className="s-16">₣</strong>),
          }}
          value={saleFields.starting_price}
          name="starting_price"
          onChange={handleChangeSaleField}
        />
      </div>

      <div className="mt-3" hidden={saleFields.sale_type !== 'Bid Price'}>
        <label>Sale duration</label>
        <TextField fullWidth select value={saleFields.bid_duration} name="bid_duration" onChange={handleChangeSaleField}>
          <MenuItem value="-" disabled>Choose duration</MenuItem>
          <MenuItem value={3}>3 days</MenuItem>
          <MenuItem value={7}>7 days</MenuItem>
          <MenuItem value={14}>2 weeks</MenuItem>
          <MenuItem value={21}>3 weeks</MenuItem>
          <MenuItem value={30}>1 month</MenuItem>
        </TextField>
      </div>
    </div>
  );

  return (
    <Elements.AdminPageBase
      navigate={navigate}
      title="Market"
      breadcrumbs={(
        <div className="mt-3">
          <Link to={ROUTES.market()} className="link weight-700 black">Market</Link>
          {' '}
          /
          {' '}
          {itemId ? 'update item' : 'add new item'}
        </div>
      )}
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <Container maxWidth="md">
          <div className="flex align-items-center flex-center gap-24 mt-2">
            <div className="center">
              <img src={getImage('DataCheck', 1)} alt="Item data" />
              <div className={`mt-1 s-14 ${activeStep === 1 && 'weight-700'}`}>Item data</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('WarehouseValidate', 2)} alt="Storage placement" />
              <div className={`mt-1 s-14 ${activeStep === 3 && 'weight-700'}`}>Storage placement</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('Dollar', 3)} alt="Market sale" />
              <div className={`mt-1 s-14 ${activeStep === 3 && 'weight-700'}`}>Market sale</div>
            </div>
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('Confirmation', 4)} alt="Confirmation" />
              <div className={`mt-1 s-14 ${activeStep === 3 && 'weight-700'}`}>Confirmation</div>
            </div>
          </div>

          {isLoading && <LinearProgress sx={{ mt: 3, mb: -3 }} color="inherit" />}
          <div hidden={activeStep !== 1}>
            {renderItemDataForm()}
          </div>

          <div hidden={activeStep !== 2}>
            {renderStoragePlacementForm()}
          </div>

          <div hidden={activeStep !== 3}>
            {renderMarketSaleForm()}
          </div>

          <div hidden={activeStep !== 4}>
            <div className="info-card mt-5">
              <h3>Item data</h3>
              <Divider sx={{ mt: 2 }} />

              <div className="mt-25">
                <div className="s-12">Item name</div>
                <div className="s-116 weight-700 mt-1">{itemFields.name}</div>
              </div>

              <div className="mt-25">
                <div className="s-12">Item volume</div>
                <div className="s-116 weight-700 mt-1">
                  {itemFields.volume}
                  {' '}
                  ml
                </div>
              </div>

              <div className="mt-25">
                <div className="s-12">Item category</div>
                <div className="s-116 weight-700 mt-1">
                  {master.categories.filter((cat) => cat.id === itemFields.category_id)[0]?.name}
                </div>
              </div>

              <div className="mt-25">
                <div className="s-12">Item condition</div>
                <div className="s-116 weight-700 mt-1">
                  {master.conditions.filter((con) => con.id === itemFields.condition_id)[0]?.name}
                </div>
              </div>

              <div className="mt-25">
                <div className="s-12">Notes</div>
                <div className="s-116 weight-700 mt-1">{itemFields.notes}</div>
              </div>

              <div className="mt-25">
                <div className="s-12">Photos</div>
                <div className="mt-1 flex gap-8">
                  <img
                    width="120"
                    height="120"
                    alt="profile"
                    src={itemFields.photo}
                    className="rounded cover"
                  />
                </div>
              </div>
            </div>

            <div className="info-card mt-3">
              <h3>Warehouse validate</h3>
              <Divider sx={{ mt: 2 }} />

              <div className="mt-3">
                <div className="s-12">Verified item status</div>
                <div className="mt-1 inline-block">
                  <div className="flex align-items-center gap-4 pil">
                    <img src={Images.VerifiedIcon} alt="verified" />
                    <div className="s-14 weight-500">Verified items</div>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <div className="s-12">Warehouse note</div>
                <div className="s-116 weight-700 mt-1">{boxFields.warehouse_notes}</div>
              </div>

              <div className="mt-3">
                <div className="s-12">Storage site</div>
                <div className="s-116 weight-700 mt-1">
                  Row
                  {' '}
                  {boxFields.row}
                  {' '}
                  - Column
                  {' '}
                  {boxFields.column}
                </div>
              </div>

            </div>

            <div className="info-card mt-3">
              <h3>Market sale</h3>
              <Divider sx={{ mt: 2 }} />

              <div className="mt-3">
                <div className="s-12">Sale type</div>
                <div className="s-116 weight-700 mt-1">
                  {saleFields.sale_type}
                </div>

                <div className="mt-3">
                  <div className="s-12">Starting price</div>
                  <div className="s-116 weight-700 mt-1">
                    ₣
                    {' '}
                    {saleFields.starting_price}
                  </div>
                </div>

                {saleFields.sale_type === 'Bid Price'
                && (
                <div className="mt-3">
                  <div className="s-12">Bid duration</div>
                  <div className="s-116 weight-700 mt-1">
                    {saleFields.bid_duration}
                    {' '}
                    days
                  </div>
                </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-16 mt-4">
            <Button sx={{ px: 6 }} variant="outlined" className="action btn-outlined" onClick={toggleCancelPopup}>Cancel</Button>
            {Boolean(activeStep > 1)
            && <Button sx={{ px: 6 }} variant="outlined" className="action btn-outlined" onClick={() => setActiveStep(activeStep - 1)}>Back</Button>}
            <Button sx={{ px: 6 }} variant="contained" className="action btn-contained" onClick={wantToContinue}>{renderText()}</Button>
          </div>
        </Container>
      </div>

      <Elements.ConfirmationModal
        open={wantToCancel}
        desc={(
          <div>
            Are you sure want to cancel progress?
            <br />
            your progress will not be saved
          </div>
        )}
        handleClose={toggleCancelPopup}
        handleAgree={() => navigate(-1)}
      />

      <Elements.ConfirmationModal
        open={popUp && activeStep === 2}
        desc={(
          <div>
            Verify this item? Before confirming,
            <br />
            make sure the validation data is correct
          </div>
        )}
        handleClose={() => setPopUp(false)}
        handleAgree={() => nextStep(3)}
      />

      <Elements.ConfirmationModal
        open={popUp && activeStep === 4}
        desc={(
          <div>
            Before post to the market, make all of the
            <br />
            data and information are fill up and right!
          </div>
        )}
        handleClose={() => setPopUp(false)}
        handleAgree={handlePostToMarket}
        isLoading={isLoading}
      />

      <Elements.ModalBase
        maxWidth="lg"
        open={chooseBox}
        confirmText="Choose aisle"
        handleClose={() => setChooseBox(false)}
        handleAgree={checkBeforeOpenConfirmation}
        fullWidth
      >
        <Container maxWidth="md">
          <div className={classes.boxes}>
            <div className="flex space-between">
              <div>
                <div className="flex align-items-center">
                  <div>
                    <div className="weight-700">
                      {box.data?.available}
                      /
                      {box.data?.total}
                    </div>
                    <div className="s-14">available storages</div>
                  </div>
                </div>
              </div>

              <div className="flex align-self-center gap-16">
                <div className="flex align-items-center">
                  <div className="storage not_available" />
                  <div>
                    <div className="weight-700">Used storage</div>
                  </div>
                </div>
                <div className="flex align-items-center">
                  <div className="storage empty" />
                  <div>
                    <div className="weight-700">Empty storage</div>
                  </div>
                </div>
              </div>
            </div>
            <Grid container spacing={2} sx={{ mt: 2 }} justifyContent="center">
              {box.data?.data?.map((e, idx) => {
                const columnLength = e.row[0].column?.length;
                return (
                  <Grid item sm="auto" key={idx} sx={{ mb: 2 }}>
                    <div className="center">
                      <div className="s-18 weight-700">
                        Aisle
                        {' '}
                        {e.name}
                      </div>
                    </div>
                    <table className="mt-3">
                      <thead>
                        <tr>
                          <td aria-label="empty-td" />
                          {new Array(columnLength).fill(null).map((col, id) => (
                            <td className="s-10 center weight-700 mute" key={id}>{id + 1}</td>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {e.row.map((ev, i) => (
                          <tr key={i}>
                            <td className="s-14">{alphabets[i]}</td>
                            {ev.column.map((col) => (
                            // rack
                              <td key={col.id} aria-label={col.id}>
                                <div
                                  className={`storage pointer ${col.status} ${col.id === selectedRack.id ? 'selected' : ''}`}
                                  onClick={() => handleSelectRack(col)}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </Container>
      </Elements.ModalBase>

      <Elements.ConfirmationModal
        open={confirmRack}
        handleClose={() => setConfirmRack(false)}
        handleAgree={chooseRack}
        desc="Are you sure choose this aisle?"
      />
    </Elements.AdminPageBase>
  );
}
